var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { invalidateTokens } from "./auth/slice";
import { removeRefreshToken } from "./auth/refreshTokenStorage";
import baseApi from "./api";
// TODO: Implement in side-effects instead
export default createAsyncThunk("resetState", (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    // This might look redundant, but we want to make sure that
    // when emptying the state triggers any side-effects, it doesn't find a refresh token
    yield removeRefreshToken();
    dispatch(invalidateTokens());
    dispatch(baseApi.util.resetApiState());
}));
